<div class="payment-advise-info-container">
  <mb-icon-text class="icon-text" [ngSwitch]="paymentText">
    <mb-icon class="icon" icon="info"></mb-icon>
    <span *ngSwitchCase="'DEPOSIT_REQUIRED'">
      <span class="bold-text">Pagá una parte antes de tu estadía</span> y el resto en el
      alojamiento.</span
    >
    <span *ngSwitchCase="'NOT_DEPOSIT_REQUIRED'">
      <span class="bold-text">Pagá el total en el alojamiento,</span> te pediremos una
      tarjeta a modo de garantía.</span
    >
    <span *ngSwitchCase="'NOT_REFUNDABLE'">
      <span class="bold-text">Pagá el total antes de la llegada</span> al
      alojamiento.</span
    >
    <span *ngSwitchCase="'IS_ARGENTINIAN'">Pagá en cuotas</span>
    <span *ngSwitchCase="'NOT_ARGENTINIAN'">
      <span class="bold-text">Pagá ahora en 1 cuota</span><br />
      en pesos argentinos</span
    >
    <span *ngSwitchCase="'NOT_ARGENTINIAN_USD'">
      <span class="bold-text"
        >Pagá ahora en 1 pago<br />
        en dólares</span
      ></span
    >
    <span *ngSwitchCase="'CREDIT_CARD'"
      >Necesitás una tarjeta de crédito para garantizar la reserva.</span
    >
  </mb-icon-text>
</div>
